import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

/**
 * Customer member role types.
 * - owner: Full control over the customer account
 * - admin: Administrative access
 * - billing: Billing and payment management
 * - tech: Technical/engineering access
 *
 * @since 1.0.0
 */
export const CustomerMemberRole = Schema.Literal("owner", "admin", "billing", "tech");
export type CustomerMemberRole = Schema.Schema.Type<typeof CustomerMemberRole>;

/**
 * Customer member model mapping a customer to a person with a role.
 *
 * @since 1.0.0
 */
export class CustomerMember extends Model.Class<CustomerMember>("CustomerMember")({
  id: Model.Generated(Schema.String),
  customerId: Schema.String,
  personId: Schema.String,
  role: CustomerMemberRole,
  createdAt: Model.DateTimeInsertFromDate,
  updatedAt: Model.DateTimeUpdateFromDate,
}) {}
